import Model from './Model'
import { toCurrency } from '@utils'

export default class MaterialSupplier extends Model
{
    getSubtitleArray () {
        return [
            this.description,
            `Buying At ${toCurrency(this.cost)}` + (this.vat_rate ? ` + ${this.vat_rate}% VAT` : ''),
            this.sku,
            `Last updated on ${this.last_updated}`,
        ]
    }

    getFormAttributes () {
        return this.only(['cost', 'sku', 'description', 'quantity_of_purchase', 'vat_rate'])
    }

    static async create (attributes) {
        attributes = this.parseDropdownAttributes(attributes, ['company_id']);
        const url = route('api.v1.material-suppliers.create')
        const { data } = await Http.post(url, attributes)
        return this.make(data)
    }

    async update (attributes = {}) {
        const url = route('api.v1.material-suppliers.update', this.id)
        const payload = { ...this.getFormAttributes(), ...attributes }
        const { data } = await Http.put(url, payload)
        return this.fill(data)
    }

    async delete () {
        await Http.delete(route('api.v1.material-suppliers.delete', this.id))
    }
}
